import { render, staticRenderFns } from "./frontTramiteContainer.vue?vue&type=template&id=36468169&"
import script from "./frontTramiteContainer.vue?vue&type=script&lang=js&"
export * from "./frontTramiteContainer.vue?vue&type=script&lang=js&"
import style0 from "./frontTramiteContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports